document.addEventListener('DOMContentLoaded', () => {

  const header = document.getElementById('header-menu');

  if (header) {
    const bodyEl = document.body;
    const desktopMenu = document.querySelector('.desktopHeader');
    const mobileMenu = document.querySelector('.mobileHeader');
    const scrollThreshold = 1;
    let ticking = false;

    // Use requestAnimationFrame for better performance
    function updateScrollClasses() {
      const scrollPosition = window.scrollY || window.pageYOffset;

      if (scrollPosition >= scrollThreshold) {
        bodyEl.classList.add('body-scrolled');
        if (desktopMenu) desktopMenu.classList.add('fixed');
        if (mobileMenu) mobileMenu.classList.add('fixed');
      } else {
        bodyEl.classList.remove('body-scrolled');
        if (desktopMenu) desktopMenu.classList.remove('fixed');
        if (mobileMenu) mobileMenu.classList.remove('fixed');
      }

      // Ensure header menu visibility
      header.classList.remove('invisible');

      ticking = false;
    }

    function requestTick() {
      if (!ticking) {
        window.requestAnimationFrame(updateScrollClasses);
        ticking = true;
      }
    }

    // Initial call
    updateScrollClasses();

    // Use passive listener for better scroll performance
    window.addEventListener('scroll', requestTick, { passive: true });
  }
});
document.addEventListener("DOMContentLoaded", function () {

  const mainHeader = document.querySelector('.mainHeader');

  if (mainHeader) {

    const bodyEl = document.querySelector('body');

    const desktopMenu = document.querySelector('.desktopHeader');
    const logos = document.querySelectorAll('header .logo');

    // const popup = document.querySelector('.menuPopup');
    // const nav = document.querySelector('.menuPopup__nav');
    // const closePopup = document.querySelector('.menuPopup__close');

    // /*
    // * open popup
    // */

    // function showTiles() {
    //   var tl = gsap.timeline();

    //   // show tiles
    //   tl.to("ul.transition li", {
    //     duration: .2,
    //     scaleY: 1,
    //     transformOrigin: "bottom left",
    //     stagger: .2
    //   })

    //   gsap.fromTo(".menuPopup__nav, .menuPopup__close", 1, {
    //     opacity: 0,
    //     y: 50,
    //   }, {
    //     opacity: 1,
    //     y: 0,
    //     delay: 1,
    //   });

    // }

    // document.querySelectorAll("li.menu-item-has-children .header__nav-menu-anchor").forEach(anchor => {
    //   anchor.addEventListener('click', function (e) {
    //     e.preventDefault();

    //     if (popup.classList.contains("menuPopup--open")) {
    //       return;
    //     } else {
    //       popup.classList.add("menuPopup--open");

    //       document.body.classList.add("overflow-hidden");
    //       showTiles();
    //     }
    //   });
    // });

    // /*
    // * close popup
    // */

    // function hideTiles() {
    //   var tl = gsap.timeline();
    //   gsap.fromTo(".menuPopup__nav, .menuPopup__close", 1, {
    //     opacity: 1,
    //     y: 0,
    //   }, {
    //     opacity: 0,
    //     y: -50,
    //   });
    //   tl.to("ul.transition li", {
    //     duration: 0.6,
    //     scaleY: 0,
    //     transformOrigin: "bottom left",
    //     stagger: {
    //       each: .2,
    //       from: 'end'
    //     }
    //   });

    //   var popup = document.getElementsByClassName("menuPopup");
    //   popup[0].classList.remove("menuPopup--open");

    // }

    // closePopup.addEventListener('click', function (e) {
    //   setTimeout(function () {
    //     popup.classList.remove("menuPopup--open");
    //   }, 1000);
    //   document.body.classList.remove("overflow-hidden");
    //   hideTiles();
    // });

    /*
    * modile logo
    */

    const mobileMenu = document.querySelector('.mobileHeader');
    if (mobileMenu) {
      const hamburgerLogo = mobileMenu.querySelector('.hamburger__logo');
    }

    /*
    * add fixed class on scroll
    */

    let scrollTimeout;
    let isScrolling = false;

    window.addEventListener('DOMContentLoaded', () => {
      const scrollThreshold = 1;
      updateScrollClasses(scrollThreshold);
    });

    window.addEventListener('scroll', () => {
      const scrollThreshold = 1;

      // Remove show class immediately when scrolling starts
      if (desktopMenu && desktopMenu.classList.contains('fixed')) {
        desktopMenu.classList.remove('show');
      }
      if (mobileMenu && mobileMenu.classList.contains('fixed')) {
        mobileMenu.classList.remove('show');
      }

      // Clear any existing timeout
      clearTimeout(scrollTimeout);
      isScrolling = true;

      updateScrollClasses(scrollThreshold);

      // Set timeout to detect when scrolling stops
      scrollTimeout = setTimeout(() => {
        isScrolling = false;
        // Add show class after 1 second of no scrolling
        if (desktopMenu && desktopMenu.classList.contains('fixed')) {
          desktopMenu.classList.add('show');
        }
        if (mobileMenu && mobileMenu.classList.contains('fixed')) {
          mobileMenu.classList.add('show');
        }
      }, 1000);
    });

    function updateScrollClasses(scrollThreshold) {
      const scrollPosition = window.scrollY;

      if (scrollPosition >= scrollThreshold) {
        bodyEl.classList.add('body-scrolled');
        desktopMenu.classList.add('fixed');
        mobileMenu.classList.add('fixed');
      } else {
        bodyEl.classList.remove('body-scrolled');
        desktopMenu.classList.remove('fixed');
        mobileMenu.classList.remove('fixed');

        // Remove show class when not fixed
        desktopMenu.classList.remove('show');
        mobileMenu.classList.remove('show');
      }

      const header = document.getElementById('header-menu');
      if (header) {
        header.classList.remove('invisible');
      }
    }



    /*
    *
    */

    let mobileHeaderHeight = mobileMenu.offsetHeight;
    const countdownElement = document.querySelector('.eventCountdown');
    let countdownHeight = (countdownElement && countdownElement.style.display !== 'none') ? countdownElement.offsetHeight : 0;

    if (mobileHeaderHeight > 0) {
      let headerHeight = mobileHeaderHeight + countdownHeight;
      let fixedHeaderHeight = (mobileHeaderHeight - 43) + countdownHeight;
      bodyEl.style.setProperty('--header-height', headerHeight + "px");
      bodyEl.style.setProperty('--header-height-scrolled', fixedHeaderHeight + "px");
    } else {
      let headerHeight = desktopMenu.offsetHeight + countdownHeight;
      let fixedHeaderHeight = (desktopMenu.offsetHeight - 43) + countdownHeight;
      bodyEl.style.setProperty('--header-height', headerHeight + "px");
      bodyEl.style.setProperty('--header-height-scrolled', fixedHeaderHeight + "px");
    }



    /*
    * animating the dropdown menu on hover
    */

    const navLinks = desktopMenu.querySelectorAll(".nav-link.dropdown-toggle");

    navLinks.forEach((navLink) => {
      const navItem = navLink.closest(".nav-item");
      const dropdownMenu = navItem.querySelector(".dropdown-menu");

      navItem.addEventListener("mouseenter", function (e) {
        handleNavHover(e, true, dropdownMenu);
      });

      navItem.addEventListener("mouseleave", function (e) {
        handleNavHover(e, false, dropdownMenu);
      });

    });

    function handleNavHover(e, isHoverIn, dropdownMenu) {
      if (window.innerWidth > 1199) {
        const targetNavItem = e.currentTarget;

        if (targetNavItem) {
          targetNavItem.classList.toggle("show", isHoverIn);

          // small timeout to check if the mouse is still hovering
          setTimeout(function () {
            if (
              !targetNavItem.matches(":hover") &&
              dropdownMenu && // check if dropdownMenu is defined
              !dropdownMenu.matches(":hover")
            ) {
              // targetNavItem.classList.remove("show");
            }
          }, 1);
        }
      }
    }



    /*
    * change aria-expanded on link hover to true (for accessibility)
    */

    const ariaElements = document.querySelectorAll('.desktopMenu [aria-expanded="false"]');

    // Add a hover event listener to toggle aria-expanded
    ariaElements.forEach(element => {
      element.addEventListener('mouseover', () => {
        element.setAttribute('aria-expanded', 'true');
      });
      element.addEventListener('mouseout', () => {
        element.setAttribute('aria-expanded', 'false');
      });
    });


    /*
    * FOUC prevention
    */

    desktopMenu.classList.add('visible');


    /*
    * opening and closing the popup menu
    */

    const mobileHeaderTrigger = document.querySelector('.mobileHeader__trigger');
    const mobileHeaderTriggerLines = document.querySelectorAll('.mobileHeader__trigger-line');
    const popupMenu = mobileMenu.querySelector('.popupMenu');
    const parentUl = mobileMenu.querySelector('.popupMenu__nav-ul');
    const topLevelNavListItems = mobileMenu.querySelectorAll('.popupMenu__nav > .popupMenu__nav-ul > li, .popupMenu__ctas > li');

    mobileHeaderTrigger.addEventListener('click', () => {
      const isOpen = mobileHeaderTrigger.classList.contains('open');
      const duration = 0.2;

      const onComplete = () => {
        popupMenu.classList.toggle('open', !isOpen);
      };

      // animate lines
      gsap.to(mobileHeaderTriggerLines[0], { rotation: isOpen ? 0 : 45, y: isOpen ? 0 : 8, duration });
      gsap.to(mobileHeaderTriggerLines[1], { opacity: isOpen ? 1 : 0, duration });
      gsap.to(mobileHeaderTriggerLines[2], { rotation: isOpen ? 0 : -45, y: isOpen ? 0 : -8, duration });
      // make the popup slide in
      gsap.to(popupMenu, { x: isOpen ? '100%' : '0%', duration: 0.3, onComplete });

      if (!isOpen) {
        // animate each li element in stagger effect
        gsap.from(topLevelNavListItems, { delay: 0.3, opacity: 0, y: -10, duration: 0.2, stagger: 0.1 });

        mobileHeaderTrigger.classList.add('open');
        document.body.classList.add('overflow-hidden');
        mobileMenu.classList.add('mobileHeader-open');
      } else {
        mobileHeaderTrigger.classList.remove('open');
        document.body.classList.remove('overflow-hidden');
        mobileMenu.classList.remove('mobileHeader-open');
      }
    });


    /*
    * opening submenus on click
    */

    const submenuTriggers = mobileMenu.querySelectorAll('.popupMenu--has-submenu');

    submenuTriggers.forEach((trigger) => {

      const parentLink = trigger.querySelector('.popupMenu__parentLink');
      const submenu = trigger.querySelector('.popupMenu__submenu');

      parentLink.addEventListener('click', (event) => {
        event.preventDefault();

        const isOpen = parentLink.parentNode.classList.contains('active');

        submenuTriggers.forEach((otherTrigger) => {
          if (otherTrigger !== trigger && otherTrigger.querySelector('.popupMenu__parentLink').parentNode.classList.contains('active')) {
            const otherSubmenu = otherTrigger.querySelector('.popupMenu__submenu');
            otherTrigger.querySelector('.popupMenu__parentLink').parentNode.classList.remove('active');
            gsap.to(otherSubmenu, {
              height: 0,
              duration: 0.3,
              ease: 'power2.inOut',
            });
          }
        });

        parentLink.parentNode.classList.toggle('active', !isOpen);

        gsap.to(submenu, {
          height: isOpen ? 0 : 'auto',
          duration: 0.3,
          ease: 'power2.inOut',
        });

      });

    });

    /*
    * end
    */

  }

});
